module.exports = __webpack_public_path__ + "img/discover.889d5dca.png";